import { render, staticRenderFns } from "./receiving.vue?vue&type=template&id=dfe7f3f2&"
import script from "./receiving.vue?vue&type=script&lang=ts&"
export * from "./receiving.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports